import { Omit, Partial } from '@40seas/entities/common';
import { AiprizeCompany } from './aiprize.company.entity';
import { SegmentEntityFieldsArray } from '@40seas/models';

export class UpdateAiprizeCompanyDto extends Partial(Omit(AiprizeCompany, [...SegmentEntityFieldsArray])) {}
